export default "__VITE_ASSET__k1GNFur$__"